<img
  *ngIf="mostrarImg"
  [src]="rutaImagen"
  height="35"
  width="35"
  alt=""/>
<label for="{{id}}" [class]="claseLabel">{{label}}</label>

<ng-select [items]="comboBox"
           bindValue="{{idOpcion}}"
           bindLabel="{{opcion}}"
           (change)=modelChanged(this)
           [(ngModel)]="value"
           [ngClass]="{'is-invalid': control.invalid && control.dirty, 'is-valid': control.valid && control.dirty}"
           [clearable]=clearContenido
           [disabled]="habilitar"
           required>
</ng-select>

<br />

